import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { insert, range, without, times, values, pick, indexOf, toLower, split, slice } from 'ramda';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';
import { withSession } from 'containers/SessionProvider';

import { actions } from 'store/newDocumentStore';
// import { actions } from 'store/studyTokens';

import ActionButton from 'components/ActionButton';

import SDMTProcedure from '../components/SDMTProcedure';
import { getLatestUnfinishedCommit } from 'lib/documentHandling';

// TODO: Move config to different place

const PHASE_TRANSITION_SECONDS = 5;
const TEST_TIME_SECONDS = 90;

const NUMBER_OF_PRACTICE_ITEMS = 10;
const NUMBER_OF_TEST_ITEMS = 110;

const FIGURES = {
  FIG_1: 'figure_1',
  FIG_2: 'figure_2',
  FIG_3: 'figure_3',
  FIG_4: 'figure_4',
  FIG_5: 'figure_5',
  FIG_6: 'figure_6',
  FIG_7: 'figure_7',
  FIG_8: 'figure_8',
  FIG_9: 'figure_9',
};

export const TEST_PHASES = {
  INSTRUCTIONS: 'instructions',
  PRACTICE: 'practice',
  PRACTICE_END: 'practiceEnded',
  TEST_TRANSITION: 'testTransition',
  TEST: 'test',
  TEST_ENDED: 'testEnded',
};

const initialState = {
  currentPhase: null,
  phaseTransitionTimeLeft: PHASE_TRANSITION_SECONDS,

  inceptionTS: null,
  practiceStartTS: null,
  practiceEndTS: null,
  testStartTS: null,
  testEndTS: null,
  testTimeLeft: TEST_TIME_SECONDS,

  rightAnswerCount: 0,

  practiceItemId: null,
  testItemId: null,

  sdmtKey: [],
  testMode: '',
  useSpeechRecognition: false,
  practiceItems: [],
  practiceAnswers: [],
  testItems: [],
  testAnswers: [],
};

const getRandomIndex = arr => arr[Math.floor(Math.random() * arr.length)];

const predeterminedKey = [
  { figure: FIGURES.FIG_1, expectedAnswer: 1 },
  { figure: FIGURES.FIG_2, expectedAnswer: 2 },
  { figure: FIGURES.FIG_3, expectedAnswer: 3 },
  { figure: FIGURES.FIG_4, expectedAnswer: 4 },
  { figure: FIGURES.FIG_5, expectedAnswer: 5 },
  { figure: FIGURES.FIG_6, expectedAnswer: 6 },
  { figure: FIGURES.FIG_7, expectedAnswer: 7 },
  { figure: FIGURES.FIG_8, expectedAnswer: 8 },
  { figure: FIGURES.FIG_9, expectedAnswer: 9 },
];

const predeterminedPracticeItems = [1, 5, 2, 1, 3, 6, 2, 4, 1, 6];

const predeterminedTestItems = [
  2, 1, 6, 1, 2, 4, 6, 1, 2, 5, 6, 3, 4, 1, 2, 6, 9, 4, 3, 8, 4, 5, 7, 8, 1, 3, 7, 4, 8, 5, 2, 9, 3, 4, 7, 2, 4, 5, 1,
  6, 4, 1, 5, 6, 7, 9, 8, 3, 6, 4, 9, 5, 8, 3, 6, 7, 4, 5, 2, 3, 7, 9, 2, 8, 1, 6, 9, 7, 2, 3, 6, 4, 9, 1, 7, 2, 5, 6,
  8, 4, 2, 8, 7, 9, 3, 7, 8, 5, 1, 9, 2, 1, 4, 3, 6, 5, 2, 1, 6, 4, 2, 1, 6, 9, 7, 3, 5, 4, 8, 9,
];

const numGrammarEN = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
const numGrammarFI = ['yksi', 'kaksi', 'kolme', 'neljä', 'viisi', 'kuusi', 'seitsemän', 'kahdeksan', 'yhdeksän'];
const numGrammarSE = ['ett', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio'];

const generatePredetermidedItems = (sdmtKey, itemSequence) =>
  times(id => {
    const figure = sdmtKey[itemSequence[id] - 1];
    return { id, ...figure };
  }, itemSequence.length);

// TODO: Refactor
const generateKey = figures => {
  let keyRange = range(1, 10);
  return values(figures).map(k => {
    const answerNumber = getRandomIndex(keyRange);
    keyRange = without([answerNumber], keyRange);
    return { figure: k, expectedAnswer: answerNumber };
  });
};

const generateItems = (sdmtKey, numberOfItems) => {
  let prevFigure = {};
  return times(id => {
    let figure = getRandomIndex(sdmtKey);
    while (figure === prevFigure) {
      figure = getRandomIndex(sdmtKey);
    }
    prevFigure = figure;
    return { id, ...figure };
  }, numberOfItems);
};

const getTs = () => Date.now().valueOf();

const makeAnswer = answer => ({ ts: getTs(), answer });

const calculateResult = (items, answers) => {
  return answers.map((a, i) => a.answer === items[i].expectedAnswer).filter(f => f).length;
};

const numberAnswer = transcript => {
  let words = split(' ', toLower(transcript));
  while (words.length > 0) {
    let num = indexOf(toLower(words[0]), numGrammarEN);
    num = num < 0 ? indexOf(toLower(words[0]), numGrammarFI) : num;
    num = num < 0 ? indexOf(toLower(words[0]), numGrammarSE) : num;
    if (num >= 0) {
      return num + 1;
    }
    for (let i = 0; i < words[0].length; i++) {
      if (!isNaN(parseInt(words[0][i]))) {
        return parseInt(words[0][i]);
      }
    }
    words = slice(1, Infinity, words);
  }
  return null;
};

class SDMTContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
    this.transitionTimer = null;
    this.recognition = null;
  }

  initializeSpeechRecognition = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList;
    const SpeechRecognitionEvent = window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent;

    this.recognition = new SpeechRecognition();
    const speechRecognitionList = new SpeechGrammarList();

    let grammar = '#JSGF V1.0; grammar numbers; public <number> = ';

    switch (this.props.session.lang) {
      case 'fi':
        grammar += numGrammarFI.join(' | ');
        this.recognition.lang = 'fi-FI';
        break;

      case 'se':
        grammar += numGrammarSE.join(' | ');
        this.recognition.lang = 'sv-SE';
        break;

      default:
        grammar += numGrammarEN.join(' | ');
        this.recognition.lang = 'en-US';
        break;
    }
    grammar += ' ;';

    speechRecognitionList.addFromString(grammar, 1);
    this.recognition.grammars = speechRecognitionList;
    this.recognition.continuous = false;
    this.recognition.interimResults = true;
    this.recognition.maxAlternatives = 3;

    this.recognition.onresult = function (event) {
      let isLastItem = false;
      let onAnswer = null;
      let result = event.results[0][0].transcript;
      let interimTranscript = '';

      if (this.state.currentPhase === TEST_PHASES.PRACTICE) {
        isLastItem = this.state.practiceItemId >= this.state.practiceItems.length;
        onAnswer = this.insertPracticeAnswer;
      }
      if (this.state.currentPhase === TEST_PHASES.TEST) {
        isLastItem = this.state.testItemId >= this.state.testItems.length;
        onAnswer = this.insertTestAnswer;
      }

      for (let i = event.resultIndex; i < event.results.length; ++i) {
        // if (event.results[i].isFinal && event.results[i][0].confidence > 0)
        const resNumber = numberAnswer(event.results[i][0].transcript);
        if (resNumber != null) {
          this.recognition.abort();
          onAnswer(resNumber);
        }
      }
    };
    this.recognition.onresult = this.recognition.onresult.bind(this);

    this.recognition.onend = function () {
      let notLastItem = false;

      if (this.state.currentPhase === TEST_PHASES.PRACTICE) {
        notLastItem = this.state.practiceItemId < this.state.practiceItems.length;
      }
      if (this.state.currentPhase === TEST_PHASES.TEST) {
        notLastItem = this.state.testItemId < this.state.testItems.length;
      }
      if (notLastItem) {
        try {
          this.recognition.start();
        } catch (DOMException) {
          // Tried to start recognition after it has already started - safe to swallow this error
        }
      }
    };
    this.recognition.onend = this.recognition.onend.bind(this);
  };

  beginTestProcedure = () => {
    const sdmtKey = predeterminedKey; // generateKey(FIGURES);
    this.setState(state => ({
      ...state,
      testMode: 'self',
      sdmtKey,
      practiceItems: generatePredetermidedItems(sdmtKey, predeterminedPracticeItems), //generateItems(sdmtKey, NUMBER_OF_PRACTICE_ITEMS)
      testItems: generatePredetermidedItems(sdmtKey, predeterminedTestItems), //generateItems(sdmtKey, NUMBER_OF_TEST_ITEMS)
      currentPhase: TEST_PHASES.INSTRUCTIONS,
      inceptionTS: getTs(),
      practiceItemId: 0,
      testItemId: 0,
    }));
  };

  beginOralTestProcedure = () => {
    const sdmtKey = predeterminedKey; // generateKey(FIGURES);
    this.setState(state => ({
      ...state,
      testMode: 'oral',
      sdmtKey,
      practiceItems: generatePredetermidedItems(sdmtKey, predeterminedPracticeItems),
      testItems: generatePredetermidedItems(sdmtKey, predeterminedTestItems),
      currentPhase: TEST_PHASES.INSTRUCTIONS,
      inceptionTS: getTs(),
      practiceItemId: 0,
      testItemId: 0,
    }));
  };

  useSpeechRecognition = useSR => {
    this.setState(state => ({
      ...state,
      useSpeechRecognition: useSR,
    }));
  };

  beginPractice = () => {
    this.setState(state => ({
      ...state,
      currentPhase: TEST_PHASES.PRACTICE,
    }));
    if (this.state.testMode === 'oral' && this.state.useSpeechRecognition) {
      this.initializeSpeechRecognition();
      this.recognition.start();
    }
  };

  insertPracticeAnswer = answer => {
    if (this.state.currentPhase !== TEST_PHASES.PRACTICE) {
      return;
    }
    const isLastItem = this.state.practiceItemId + 1 >= this.state.practiceItems.length;
    if (this.state.testMode === 'oral' && answer === 10) {
      answer = this.state.practiceItems[this.state.practiceItemId].expectedAnswer;
    }
    this.setState(state => ({
      ...state,
      practiceStartTS: state.practiceStartTS || getTs(),
      currentPhase: isLastItem ? TEST_PHASES.PRACTICE_END : state.currentPhase,
      practiceEndTS: isLastItem ? getTs() : state.practiceEndTS,
      practiceItemId: isLastItem ? null : state.practiceItemId + 1,
      practiceAnswers: insert(state.practiceItemId, makeAnswer(answer), state.practiceAnswers),
    }));
  };

  insertTestAnswer = answer => {
    if (this.state.currentPhase != TEST_PHASES.TEST) {
      return;
    }
    const isLastItem = this.state.testItemId + 1 >= this.state.testItems.length;
    if (this.state.testMode === 'oral' && answer === 10) {
      answer = this.state.testItems[this.state.testItemId].expectedAnswer;
    }
    this.setState(state => ({
      ...state,
      currentPhase: isLastItem ? TEST_PHASES.TEST_ENDED : state.currentPhase,
      testEndTS: isLastItem ? getTs() : state.testEndTS,
      testItemId: isLastItem ? null : state.testItemId + 1,
      testAnswers: insert(state.testItemId, makeAnswer(answer), state.testAnswers),
    }));
    if (isLastItem) {
      this.clearTimer();
      this.setState(state => ({
        ...state,
        rightAnswerCount: calculateResult(state.testItems, state.testAnswers || []),
      }));
    }
  };

  timerTick = () => {
    const phaseTransitionTimeLeft = Math.max(0, this.state.phaseTransitionTimeLeft - 1);
    if (phaseTransitionTimeLeft > 0) {
      // We're currently transitioning to test phase.
      this.setState(state => ({
        ...state,
        currentPhase: TEST_PHASES.TEST_TRANSITION,
        phaseTransitionTimeLeft: phaseTransitionTimeLeft,
      }));
    }
    if (phaseTransitionTimeLeft <= 0) {
      // Transition timer has ran out so the test has either started or ended
      const testTimeLeft = Math.max(0, this.state.testTimeLeft - 1);
      if (testTimeLeft <= 0) {
        // Test timer has ran out. Test has ended. Finalize state and clear timer.
        this.setState(state => ({
          ...state,
          currentPhase: TEST_PHASES.TEST_ENDED,
          testEndTS: state.testEndTS || getTs(),
          testTimeLeft: 0,
          rightAnswerCount: calculateResult(state.testItems, state.testAnswers || []),
        }));
        this.clearTimer();
        if (this.recognition != null) {
          this.recognition.stop();
        }
        return;
      } else {
        // There is still time left in the test clock. Test is in progress.
        this.setState(state => ({
          ...state,
          currentPhase: TEST_PHASES.TEST,
          phaseTransitionTimeLeft: 0,
          testTimeLeft: testTimeLeft,
          testStartTS: state.testStartTS || getTs(),
        }));
      }
    }
    this.transitionTimer = setTimeout(this.timerTick, 1000);
  };

  startTest = () => {
    if (this.state.testMode === 'oral' && this.state.useSpeechRecognition) {
      this.initializeSpeechRecognition();
      this.recognition.start();
    }
    this.timerTick();
  };

  clearTimer = () => {
    if (this.transitionTimer) {
      clearTimeout(this.transitionTimer);
      this.transitionTimer = null;
    }
  };

  cancelTest = () => {
    if (this.recognition != null) {
      this.recognition.stop();
    }
    this.clearTimer();
    this.setState(() => ({ ...initialState }));
  };

  saveResult = () => {
    if (!this.state.currentPhase === TEST_PHASES.TEST_ENDED) return;
    const result = pick(
      ['testMode', 'useSpeechRecognition', 'testItems', 'testAnswers', 'testStartTS', 'testEndTS', 'rightAnswerCount'],
      this.state,
    );
    // this.props.consumeToken(this.props.token._id);
    this.props.commitPut(
      'sdmt',
      this.props.editingDocumentId,
      getLatestUnfinishedCommit(this.props.editingDocument).commitId,
      {
        sdmtResult: result,
      },
    );
    this.setState(() => ({ ...initialState }));
  };

  componentWillUnmount() {
    this.cancelTest();
  }

  render() {
    return (
      <div>
        {!this.state.inceptionTS && (
          <Row center="xs">
            {/* <Col>
              <ActionButton border secondary localeId="sdmt.beginProcedure" onClick={this.beginTestProcedure} />
            </Col> */}
            <Col>
              <ActionButton border secondary localeId="sdmt.beginOralProcedure" onClick={this.beginOralTestProcedure} />
            </Col>
          </Row>
        )}
        <SDMTProcedure
          saveResult={this.saveResult}
          beginPractice={this.beginPractice}
          onSpeechRecognition={this.useSpeechRecognition}
          cancelTest={this.cancelTest}
          startTest={this.startTest}
          onPracticeAnswer={this.insertPracticeAnswer}
          onTestAnswer={this.insertTestAnswer}
          {...this.state}
        />
      </div>
    );
  }
}

SDMTContainer.propTypes = {
  input: PropTypes.object,
  session: PropTypes.object,
  editingDocumentId: PropTypes.string,
  editingDocument: PropTypes.object,
};
// connect(mapStateToProps, { cancel, done, clearViewId })
export default connect(null, { commitPut: actions.updateCommit })(withSession(SDMTContainer));
